export enum Day {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export function StringToDay(day: string): Day {
  switch (day.toLowerCase().trim()) {
    case "monday":
      return Day.MONDAY;
    case "tuesday":
      return Day.TUESDAY;
    case "wednesday":
      return Day.WEDNESDAY;
    case "thursday":
      return Day.THURSDAY;
    case "friday":
      return Day.FRIDAY;
    case "saturday":
      return Day.SATURDAY;
    case "sunday":
      return Day.SUNDAY;
    default:
      throw Error(`${day} is not configured to be converted to enum Day`);
  }
}

export function DayToString(day: Day): string {
  switch (day) {
    case Day.MONDAY:
      return "MONDAY";
    case Day.TUESDAY:
      return "TUESDAY";
    case Day.WEDNESDAY:
      return "WEDNESDAY";
    case Day.THURSDAY:
      return "THURSDAY";
    case Day.FRIDAY:
      return "FRIDAY";
    case Day.SATURDAY:
      return "SATURDAY";
    case Day.SUNDAY:
      return "SUNDAY";
    default:
      throw Error(`${day} is not configured to be converted to a string`);
  }
}
